import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_REPORTE_DESCARGA } from '../../../../../config/tables'

function ReporteDescargaExportadorCereal () {
  return (
    <MuiTable id={TABLA_REPORTE_DESCARGA} />
  )
}

export default ReporteDescargaExportadorCereal
